export default "__VITE_ASSET__C5bDwi1b__"